import * as yup from "yup";

export const QualificationValidation = yup.object().shape({
    name: yup.string().required("Required"),
    status: yup.string().required("Required"),
});